import { recoveryCodesApi } from "../api";

const RecoveryCodeService = {
    generateCodes: async (email: string) => {
        try {
            const response = await recoveryCodesApi.addWithoutData(`/generate?email=${email}`);
            return response.data; // Devuelve los códigos de recuperación generados
        } catch (error: any) {
            throw { message: error.response?.data?.message || "Error al generar códigos de recuperación" };
        }
    }
};

export default RecoveryCodeService;
